import React from "react";
import {useDocumentTranslation} from "../documents/documentContext";
import ShareIcon from "@mui/icons-material/Share";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

/**
 * A single share button that opens the unified ModelSharingDialog.
 * Replaces the previous split-button dropdown (private / public / history).
 *
 * @param {Function} callback    - Called (with no arguments) to open the dialog.
 * @param {boolean}  showLabel   - Whether to show the text label beside the icon.
 */
export const ButtonShare = ({callback, showLabel}) => {
    const t = useDocumentTranslation();
    return (
        <Tooltip title={t('btnShareTooltip', 'Deling')}>
            <IconButton color="secondary"
                        onClick={callback}
                        size="small">
                <ShareIcon/>
                {showLabel && (
                    <Typography variant="caption" sx={{marginLeft: 1}}>
                        {t('btnShare', 'Del')}
                    </Typography>
                )}
            </IconButton>
        </Tooltip>
    );
};